document.addEventListener('DOMContentLoaded', function() {
  // Find all learn more buttons
  const learnMoreButtons = document.querySelectorAll('a[href="#collection-details"]');
  
  learnMoreButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const target = document.getElementById('collection-details');
      if (target) {
        // Account for sticky header
        const header = document.querySelector('.section-header, .site-header, header');
        const headerHeight = header ? header.offsetHeight : 0;
        const targetPosition = target.offsetTop - headerHeight - 20;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});